/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

import './connect-on-prem-modal.component.less';

import {
    Component,
    EventEmitter,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import {
    AVI_LOAD_BALANCER_LICENSING_GUIDE,
    BROADCOM_ENTITLEMENTS_URL,
    DEPLOYING_LICENSE_HUB_KB_URL,
    ENDPOINT_MANAGEMENT_KB_URL,
    PULSE_LICENSES_URL,
    REGISTERING_LICENSE_HUB_KB_URL,
    USAGE_REPORT_KB_URL,
} from 'ng/modules/licensing/constants';

import * as l10n from './connect-on-prem-modal.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for displaying Connect to On-prem License Hub information modal with step-by-step guide.
 * @author Shubham Bindal
 */
@Component({
    selector: 'connect-on-prem-modal',
    templateUrl: './connect-on-prem-modal.component.html',
})
export class ConnectToOnPremModalComponent {
    @Output()
    public readonly onClose = new EventEmitter<void>();

    public readonly aviLoadBalancerLicensingKbUrl = AVI_LOAD_BALANCER_LICENSING_GUIDE;

    /**
     * TODO: Replace placeholder KB URLs with actual documentation links
     * once they are available from the documentation team.
     */
    public readonly deployingLicenseHubKbUrl = DEPLOYING_LICENSE_HUB_KB_URL;
    public readonly registeringLicenseHubKbUrl = REGISTERING_LICENSE_HUB_KB_URL;
    public readonly pulseLicensesUrl = PULSE_LICENSES_URL;
    public readonly broadcomEntitlementsUrl = BROADCOM_ENTITLEMENTS_URL;
    public readonly endpointManagementKbUrl = ENDPOINT_MANAGEMENT_KB_URL;
    public readonly usageReportingKbUrl = USAGE_REPORT_KB_URL;

    public readonly l10nKeys = l10nKeys;

    constructor(private readonly l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Handle close button click.
     */
    public handleClose(): void {
        this.onClose.emit();
    }

    /**
     * Open the URL from l10n in a new tab if valid.
     */
    public handleExternalLinkClick($event: Event, url: string): void {
        $event.preventDefault();

        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
}
